module.exports = __webpack_public_path__ + "static/media/change.d14750f5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dealroom-icons/change.svg
// module id = 1924
// module chunks = 0